var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3007 16.2825L21 27.4367L1.69934 16.2825C1.1139 15.9422 0.37738 16.377 0.37738 17.0576V22.5591L21 34.4884L41.6226 22.5591V17.0576C41.6226 16.377 40.8861 15.9422 40.3007 16.2825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7661 17.9273L7.00608 14.6C6.7228 14.4487 6.57172 14.1463 6.57172 13.8249V0.893517C6.57172 0.21292 7.30824 -0.221905 7.89368 0.118393L12.7661 2.93531V17.9273Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2339 17.9273L34.9939 14.6C35.2772 14.4487 35.4283 14.1463 35.4283 13.8249V0.893517C35.4283 0.21292 34.6918 -0.221905 34.1063 0.118393L29.2339 2.93531V17.9273Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5513 5.07178L21.4344 7.45387C21.1511 7.60511 20.83 7.60511 20.5467 7.45387L16.4298 5.07178V20.0638L20.5467 22.4459C20.83 22.5971 21.1511 22.5971 21.4344 22.4459L25.5513 20.0638V5.07178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaLogo);
export default __webpack_public_path__ + "static/media/MALogo.8c1e938e1340b6055ca0df0aa3bf1356.svg";
export { ForwardRef as ReactComponent };